import React from 'react';

import { GridHeightContainer } from 'components/GridHeightContainer';
import MobileHeader from 'components/MobileHeader/index';
import SidebarHeader from 'components/SidebarHeader';

import { useIsMobile } from 'util/hooks';

import HeaderTop from './components/Header/HeaderTop';

const App = (props) => {
  const { children } = props;
  const [isMobile] = useIsMobile();
  const [expand, setExpand] = React.useState(true); // For sidebar

  const topHeader = React.useMemo(() => {
    return isMobile ? null : <HeaderTop />;
  }, [isMobile]);

  const subHeader = React.useMemo(() => {
    return isMobile ? <MobileHeader /> : <SidebarHeader setExpand={setExpand} expand={expand} />;
  }, [isMobile, expand, setExpand]);

  return (
    <React.Fragment key="App">
      <GridHeightContainer className="d-flex flex-wrap pageWrapperBlock">
        {subHeader}
        <GridHeightContainer
          className={`${expand && 'bottom-action-expanded'} content-area`}
          style={{ width: isMobile ? '100%' : expand ? 'calc(100% - 250px)' : 'calc(100% - 90px)' }}
        >
          {topHeader}
          <GridHeightContainer subtractFrom="#root .pageWrapperBlock .headerTopBar">{children}</GridHeightContainer>
        </GridHeightContainer>
      </GridHeightContainer>
    </React.Fragment>
  );
};

export default App;
